module.exports = __webpack_public_path__ + "img/room-event-star_arzh.28b1a85a.png";